import styled from 'styled-components';

export const ChipsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 15px 10px;
`;
